import { plans, shipping, hardware } from '@/data'

const StandardPlan = plans.find(plan => plan.map_key === 'standard_yearly')
const ProPlan = plans.find(plan => plan.map_key === 'pro_yearly')

const Quest2Headset = hardware.find(h => h.label === 'Meta Quest 2 Headset')
const Quest3HeadsetStandard = hardware.find(h => h.label === 'Meta Quest 3 Headset' && h.available_for?.includes('standard_yearly'))
const Quest3HeadsetPro = hardware.find(h => h.label === 'Meta Quest 3 Headset' && h.available_for?.includes('pro_yearly'))
const Quest2BatAttachment = hardware.find(h => h.category === 'bat_attachment' && h.price === 0 && h.description === 'for Quest 2')
const Quest3BatAttachment = hardware.find(h => h.category === 'bat_attachment' && h.price === 0 && h.description === 'for Quest 3')

export default [
    {
        wc_id: import.meta.env.DEV ? 3404 : 118154,
        price: 42900,
        bundle_group_key: 'metaquest2023',
        description: 'Meta Quest 2 Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...StandardPlan,
            price: 0,
            hardware_options: [Quest2Headset, Quest2BatAttachment],
        },
        equipment: [Quest2Headset, Quest2BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 7736 : 142267,
        price: 72700,
        bundle_group_key: 'metaquest3-standard',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Standard Yearly Plan',
        plan: {
            ...StandardPlan,
            price: 0,
            hardware_options: [Quest3HeadsetStandard, Quest3BatAttachment],
        },
        equipment: [Quest3HeadsetStandard, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
    {
        wc_id: import.meta.env.DEV ? 7738 : 142266,
        price: 85400,
        bundle_group_key: 'metaquest3-pro',
        description: 'Meta Quest 3 Bundle',
        badge: 'Includes Pro Yearly Plan',
        plan: {
            ...ProPlan,
            price: 0,
            hardware_options: [Quest3HeadsetPro, Quest3BatAttachment],
        },
        equipment: [Quest3HeadsetPro, Quest3BatAttachment],
        shipping_options: shipping.filter(option => option.id === 'standard'),
    },
] as Bundle[]